import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsAutoActive } from '../AutoActiveContext.js';
import { useInteraction } from '../InteractionContext.js';
import { toText } from '../layout.js';
import { BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator, Breadcrumb as ShadcnBreadcrumb, } from '../ui/breadcrumb.js';
export function Breadcrumb({ element }) {
    const { children } = element;
    const crumbChildren = children.filter((child) => child.type === 'element' && child.elementType === 'crumb');
    return (_jsx(ShadcnBreadcrumb, { children: _jsx(BreadcrumbList, { children: crumbChildren.map((child, i) => {
                const isLast = i === crumbChildren.length - 1;
                const crumbText = toText(child.content);
                const crumbKey = crumbText ? `crumb-${crumbText}` : `crumb-${i}`;
                return (_jsxs(BreadcrumbItem, { children: [_jsx(Crumb, { element: child, isLast: isLast }), !isLast && _jsx(BreadcrumbSeparator, {})] }, crumbKey));
            }) }) }));
}
export function Crumb({ element, isLast = false }) {
    const { content, props } = element;
    const { navigateTo } = useInteraction();
    const isAutoActive = useIsAutoActive(element);
    const textContent = toText(content);
    const to = props.to;
    const isActive = props.active === true || isAutoActive || isLast;
    const handleClick = (e) => {
        if (to && !isLast) {
            e.preventDefault();
            navigateTo(to);
        }
    };
    if (isLast || isActive) {
        return _jsx(BreadcrumbPage, { children: textContent });
    }
    return (_jsx(BreadcrumbLink, { href: to || '#', onClick: handleClick, children: textContent }));
}
//# sourceMappingURL=Breadcrumb.js.map